export const EVENT_DELETED = 'Evento eliminado'
export const EVENT_ADDED = 'Evento agregado'
export const EVENT_MODIFIED = 'Evento actualizado'
